import React from 'react'
import parse from 'html-react-parser';
import './cta.scss'
import Button from '../Button';
import Div from '../Div';
import Spacing from '../Spacing';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';

export default function Cta({ title, btnText, btnLink, bgSrc, variant, btn2Link, btn2Text }) {
  return (
    <Div className={`cs-cta cs-style1 cs-bg text-center cs-shape_wrap_1 cs-position_1 ${variant ? variant : ''}`} style={{ backgroundImage: `url(${bgSrc})` }}>
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="cs-cta_in">
        <h2 className="cs-cta_title cs-semi_bold cs-m0">{parse(title)}</h2>
        <div className='flex gap-4 mt-6' style={{ "marginTop": "30px" }} >
          {btnText && (
            <a href={btnLink} target='_blank' >
              <button className="mx-2 my-2 my-md-0 cs-btn cs-style1">
                <span>{btnText}</span>
                <Icon className='d-none d-md-block' icon="bi:arrow-right" />
              </button>
            </a>
          )}

          {btn2Text && (
            <Link to={btn2Link} >
              <button className="cs-btn my-2 my-md-0 mx-2 cs-style1 bg-white">
                <span className='text-black' >{btn2Text}</span>
                <Icon className='text-black d-none d-md-block' icon="bi:arrow-right" />
              </button>
            </Link>
          )}

        </div>
      </Div>
    </Div>
  )
}
